import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Colors, Typography } from '../../../theme';
import { ServiceIconShell } from '../ServiceIconShell';
const fontSizeMapping = (size, text) => {
    switch (size) {
        case 20:
            return 10;
        case 30:
            return text > 9 ? 12 : 16;
        case 40:
            return text > 9 ? 16 : 18;
        case 60:
            return text > 9 ? 18 : 24;
        case 80:
            return 32;
        case 120:
            return 48;
        case 150:
            return 60;
        default:
            return 16;
    }
};
const typography = {
    30: Typography.paragraph3Bold,
    40: Typography.paragraph1Bold,
    60: Typography.subHeader1Bold,
};
const Styles = labelStyles('ServiceIconNumeric', {
    number: (fontSize, iconSize) => (Object.assign(Object.assign({}, typography[iconSize]), { fontSize, color: Colors.neutral800, textIndent: -2 })),
});
export const ServiceIconNumeric = (props) => {
    const { size, hasBorder = true, hasWhiteBackground } = props;
    const label = `Plus ${props.number} more apps.`;
    const fontSize = fontSizeMapping(size, props.number);
    const text = props.number > 99 ? `99+` : `+${props.number}`;
    return (isolateComponent(ServiceIconShell, { size: size, hasBorder: hasBorder, hasWhiteBackground: hasWhiteBackground },
        isolateComponent("span", { "aria-label": label, css: Styles.number(fontSize, size), role: "img" },
            isolateComponent("span", { "aria-hidden": "true" }, text))));
};
//# sourceMappingURL=ServiceIconNumeric.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
